module.exports = __webpack_public_path__ + "static/img/mobile_stock_mgr.1314701d.png";